"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
function isObject(o) {
  return typeof o === 'object' && o !== null && !Array.isArray(o);
}
var _default = exports.default = isObject;